import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

(function () {
  var enterModule = (typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal : require('react-hot-loader')).enterModule;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import { EventEmitter } from 'events';
export var LogProvider =
/*#__PURE__*/
function (_EventEmitter) {
  _inherits(LogProvider, _EventEmitter);

  function LogProvider() {
    var _this;

    var limit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 50;

    _classCallCheck(this, LogProvider);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(LogProvider).call(this));

    _defineProperty(_assertThisInitialized(_this), "cachedSettings", null);

    _defineProperty(_assertThisInitialized(_this), "fromFile", false);

    _defineProperty(_assertThisInitialized(_this), "cachedEntries", []);

    _defineProperty(_assertThisInitialized(_this), "hasMore", true);

    _defineProperty(_assertThisInitialized(_this), "poll", false);

    _defineProperty(_assertThisInitialized(_this), "pollActive", false);

    _this.baseLimit = limit;
    _this.loading = false;
    _this.limit = limit;
    _this.searchQuery = '';
    return _this;
  }

  _createClass(LogProvider, [{
    key: "reset",
    value: function reset() {
      this.hasMore = true;
      this.limit = this.baseLimit;
      this.cachedEntries = [];
      this.loading = false;
    }
  }, {
    key: "load",
    value: function () {
      var _load = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var newData;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.loading = true;

                if (!(this.cachedEntries.length >= this.limit || this.fromFile || !this.hasMore)) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt("return");

              case 3:
                _context.next = 5;
                return this.loadEntries(this.cachedEntries.length, this.limit - this.cachedEntries.length);

              case 5:
                newData = _context.sent;

                if (newData.data.length === 0) {
                  this.hasMore = false;
                }

                this.cachedEntries = this.cachedEntries.concat(newData.data);
                this.loading = false;
                this.emit('entries', this.cachedEntries);

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function load() {
        return _load.apply(this, arguments);
      }

      return load;
    }()
  }, {
    key: "loadEntries",
    value: function loadEntries(offset) {
      var _this2 = this;

      var count = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 50;
      return this.getSettings().then(function (_ref) {
        var levels = _ref.levels;

        if (_this2.searchQuery) {
          return $.get(OC.generateUrl('/apps/logreader/search'), {
            offset: offset,
            count: count,
            query: _this2.query,
            levels: levels
          });
        } else {
          return $.get(OC.generateUrl('/apps/logreader/get'), {
            offset: offset,
            count: count,
            levels: levels
          });
        }
      });
    }
  }, {
    key: "getSettings",
    value: function () {
      var _getSettings = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!this.cachedSettings) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return", this.cachedSettings);

              case 2:
                _context2.next = 4;
                return $.get(OC.generateUrl('/apps/logreader/settings'));

              case 4:
                this.cachedSettings = _context2.sent;
                return _context2.abrupt("return", this.cachedSettings);

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getSettings() {
        return _getSettings.apply(this, arguments);
      }

      return getSettings;
    }()
  }, {
    key: "getLevels",
    value: function () {
      var _getLevels = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3() {
        var _ref2, levels;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.getSettings();

              case 2:
                _ref2 = _context3.sent;
                levels = _ref2.levels;
                return _context3.abrupt("return", levels.split('').map(function (level) {
                  return level > 0;
                }));

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getLevels() {
        return _getLevels.apply(this, arguments);
      }

      return getLevels;
    }()
  }, {
    key: "setLevels",
    value: function setLevels(levels) {
      var levelsString = levels.map(function (level) {
        return level ? 1 : 0;
      }).join('');

      if (this.cachedSettings) {
        this.cachedSettings.levels = levelsString;
      }

      return $.ajax({
        type: 'PUT',
        url: OC.generateUrl('/apps/logreader/levels'),
        data: {
          levels: levelsString
        }
      });
    }
  }, {
    key: "getRelative",
    value: function () {
      var _getRelative = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4() {
        var _ref3, relativedates;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.getSettings();

              case 2:
                _ref3 = _context4.sent;
                relativedates = _ref3.relativedates;
                return _context4.abrupt("return", relativedates);

              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function getRelative() {
        return _getRelative.apply(this, arguments);
      }

      return getRelative;
    }()
  }, {
    key: "getDateFormat",
    value: function () {
      var _getDateFormat = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5() {
        var _ref4, dateformat;

        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this.getSettings();

              case 2:
                _ref4 = _context5.sent;
                dateformat = _ref4.dateformat;
                return _context5.abrupt("return", dateformat);

              case 5:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function getDateFormat() {
        return _getDateFormat.apply(this, arguments);
      }

      return getDateFormat;
    }()
  }, {
    key: "getLive",
    value: function () {
      var _getLive = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee6() {
        var _ref5, live;

        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return this.getSettings();

              case 2:
                _ref5 = _context6.sent;
                live = _ref5.live;
                return _context6.abrupt("return", live);

              case 5:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function getLive() {
        return _getLive.apply(this, arguments);
      }

      return getLive;
    }()
  }, {
    key: "setRelative",
    value: function setRelative(relative) {
      return $.ajax({
        type: 'PUT',
        url: OC.generateUrl('/apps/logreader/relative'),
        data: {
          relative: relative
        }
      });
    }
  }, {
    key: "setLive",
    value: function setLive(live) {
      return $.ajax({
        type: 'PUT',
        url: OC.generateUrl('/apps/logreader/live'),
        data: {
          live: live
        }
      });
    }
  }, {
    key: "startPolling",
    value: function () {
      var _startPolling = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee7() {
        var lastReqId, newData;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                if (!(this.cachedEntries.length === 0 || this.poll || this.pollActive)) {
                  _context7.next = 2;
                  break;
                }

                return _context7.abrupt("return");

              case 2:
                this.pollActive = true;
                this.poll = true;

              case 4:
                if (!this.poll) {
                  _context7.next = 12;
                  break;
                }

                lastReqId = this.cachedEntries[0].reqId;
                _context7.next = 8;
                return $.get(OC.generateUrl('/apps/logreader/poll'), {
                  lastReqId: lastReqId
                });

              case 8:
                newData = _context7.sent;

                if (this.poll) {
                  this.cachedEntries = newData.concat(this.cachedEntries);
                  this.emit('entries', this.cachedEntries);
                }

                _context7.next = 4;
                break;

              case 12:
                this.pollActive = false;

              case 13:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function startPolling() {
        return _startPolling.apply(this, arguments);
      }

      return startPolling;
    }()
  }, {
    key: "stopPolling",
    value: function stopPolling() {
      this.poll = false;
    }
  }, {
    key: "__reactstandin__regenerateByEval",
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }, {
    key: "entries",
    get: function get() {
      return cachedEntries;
    }
  }, {
    key: "query",
    set: function set(newQuery) {
      var _this3 = this;

      if (newQuery !== this.searchQuery) {
        if (newQuery) {
          this.stopPolling();
        }

        this.searchQuery = newQuery;
        this.reset();
        this.load().then(
        /*#__PURE__*/
        _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee8() {
          return _regeneratorRuntime.wrap(function _callee8$(_context8) {
            while (1) {
              switch (_context8.prev = _context8.next) {
                case 0:
                  _context8.t0 = !newQuery;

                  if (!_context8.t0) {
                    _context8.next = 5;
                    break;
                  }

                  _context8.next = 4;
                  return _this3.getLive();

                case 4:
                  _context8.t0 = _context8.sent;

                case 5:
                  if (!_context8.t0) {
                    _context8.next = 7;
                    break;
                  }

                  _this3.startPolling();

                case 7:
                case "end":
                  return _context8.stop();
              }
            }
          }, _callee8);
        })));
      }
    },
    get: function get() {
      return this.searchQuery;
    }
  }]);

  return LogProvider;
}(EventEmitter);

_defineProperty(LogProvider, "levels", ['Debug', 'Info', 'Warning', 'Error', 'Fatal']);

;

(function () {
  var reactHotLoader = (typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal : require('react-hot-loader')).default;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(LogProvider, "LogProvider", "/srv/http/owncloud/apps/logreader/js/Providers/LogProvider.js");
})();

;

(function () {
  var leaveModule = (typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal : require('react-hot-loader')).leaveModule;
  leaveModule && leaveModule(module);
})();